"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionService = void 0;

var uuid_1 = require("uuid");

var Storage_1 = __importDefault(require("../../core/utilities/Storage"));

var SessionServiceStorage;

(function (SessionServiceStorage) {
  SessionServiceStorage["token"] = "token";
})(SessionServiceStorage || (SessionServiceStorage = {}));

var SessionService =
/** @class */
function () {
  function SessionService() {
    this.storage = new Storage_1.default("SessionService");
  }

  SessionService.getInstance = function () {
    if (!SessionService.instance) {
      SessionService.instance = new SessionService();
    }

    return SessionService.instance;
  };

  SessionService.prototype.getSessionToken = function () {
    var token = this.storage.get(SessionServiceStorage.token);

    if (token) {
      return token;
    } else {
      var newToken = uuid_1.v4();
      this.storage.put(SessionServiceStorage.token, newToken);
      return newToken;
    }
  };

  return SessionService;
}();

exports.SessionService = SessionService;